module.exports = __webpack_public_path__ + "static/media/icon_1.201d816d.svg";